
export const GET_ACCOUNTS_CREATED_PENDING = 'GET_ACCOUNTS_CREATED_PENDING';
export const GET_ACCOUNTS_CREATED_SUCCESS = 'GET_ACCOUNTS_CREATED_SUCCESS';
export const GET_ACCOUNTS_CREATED_ERROR = 'GET_ACCOUNTS_CREATED_ERROR';
export const GET_JOB_POSTS_CREATED_PENDING = 'GET_JOB_POSTS_CREATED_PENDING';
export const GET_JOB_POSTS_CREATED_SUCCESS = 'GET_JOB_POSTS_CREATED_SUCCESS';
export const GET_JOB_POSTS_CREATED_ERROR = 'GET_JOB_POSTS_CREATED_ERROR';
export const GET_CUMULATIVE_USER_COUNT_PENDING = 'GET_CUMULATIVE_USER_COUNT_PENDING';
export const GET_CUMULATIVE_USER_COUNT_SUCCESS = 'GET_CUMULATIVE_USER_COUNT_SUCCESS';
export const GET_CUMULATIVE_USER_COUNT_ERROR = 'GET_CUMULATIVE_USER_COUNT_ERROR';
export const GET_JOB_APPLICATION_COUNT_PENDING = 'GET_JOB_APPLICATION_COUNT_PENDING';
export const GET_JOB_APPLICATION_COUNT_SUCCESS = 'GET_JOB_APPLICATION_COUNT_SUCCESS';
export const GET_JOB_APPLICATION_COUNT_ERROR = 'GET_JOB_APPLICATION_COUNT_ERROR';

export function getAccountsCreatedPending() {
  return { type: GET_ACCOUNTS_CREATED_PENDING }
};

export function getAccountsCreatedSuccess(payload) {
  return { type: GET_ACCOUNTS_CREATED_SUCCESS, payload }
};

export function getAccountsCreatedError(error) {
  return { type: GET_ACCOUNTS_CREATED_ERROR, error }
};

export function getJobPostsCreatedPending() {
  return { type: GET_JOB_POSTS_CREATED_PENDING }
};

export function getJobPostsCreatedSuccess(payload) {
  return { type: GET_JOB_POSTS_CREATED_SUCCESS, payload }
};

export function getJobPostsCreatedError(error) {
  return { type: GET_JOB_POSTS_CREATED_ERROR, error }
};

export function getCumulativeUserCountPending() {
  return { type: GET_CUMULATIVE_USER_COUNT_PENDING }
};

export function getCumulativeUserCountSuccess(payload) {
  return { type: GET_CUMULATIVE_USER_COUNT_SUCCESS, payload }
};

export function getCumulativeUserCountError(error) {
  return { type: GET_CUMULATIVE_USER_COUNT_ERROR, error }
};

export function getJobApplicationCountPending() {
  return { type: GET_JOB_APPLICATION_COUNT_PENDING }
};

export function getJobApplicationCountSuccess(payload) {
  return { type: GET_JOB_APPLICATION_COUNT_SUCCESS, payload }
};

export function getJobApplicationCountError(error) {
  return { type: GET_JOB_APPLICATION_COUNT_ERROR, error }
};
